import React from 'react'
import MainHeader from "./partials/newheader";    
import Footer from "./partials/footer";
import Lounge from './Lounge';
export default function Pettipettilounge() {
  return (
    <div>
      <MainHeader />
      <Lounge />
      <Footer />
    </div>
  );
}
